import React from 'react'
import cn from 'classnames'

import styles from './PronounOptions.module.css'

type PronounOptionsProps = {
  pronouns: [
    {
      key: string
      text: string
    },
  ]
  onChange: (pronoun: string) => void
  selected: string
  isInverted?: boolean
  theme?: 'red' | 'dark'
}

const PronounOptions: React.FC<PronounOptionsProps> = ({
  pronouns,
  onChange,
  selected,
  isInverted = false,
  theme = 'red',
}) => {
  const handleClick = (pronoun: string) => {
    onChange(pronoun === selected ? undefined : pronoun)
  }

  if (!pronouns?.length) return null

  return (
    <div className={styles.pronounOptions}>
      {pronouns?.map((option) => (
        <button
          key={option.key}
          type="button"
          className={cn(styles.option, styles[theme], {
            [styles.optionSelected]: selected === option.key,
            [styles.optionInverted]: isInverted,
            [styles.optionSelectedInverted]:
              isInverted && selected === option.key,
          })}
          onClick={() => handleClick(option.key)}
        >
          <span className={styles.optionText}>{option.text}</span>
        </button>
      ))}
    </div>
  )
}

export default PronounOptions
